import { Box } from '@mui/material';
import { ReactComponent as ShoppingIcon } from 'assets/icons/Shopping.svg';

const FullscreenProgress = () => (
  <Box
    position='absolute'
    width='100%'
    height='100%'
    justifyContent='center'
    alignItems='center'
    display='flex'
  >
    {/* <CircularProgress /> */}
    <ShoppingIcon className='animate-ping' />
  </Box>
);

export default FullscreenProgress;
